export default __webpack_public_path__ + "static/Entenda0042-b95d42293b1dc6fc936d9f14bc1c182f.jpg";